import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { useWizardStore, type PlanSlug } from "@/state/wizard-store";

/**
 * Stripe Checkout returns here after a successful payment (Phase 3). Phase 2
 * gets here directly from the mock checkout URL. Either way we record the
 * plan and forward to the questionnaire.
 */
export function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const setPlan = useWizardStore((s) => s.setPlan);
  const setAddons = useWizardStore((s) => s.setAddons);

  useEffect(() => {
    const plan = params.get("plan") as PlanSlug | null;
    if (plan && ["starter", "growth", "pro"].includes(plan)) {
      setPlan(plan);
    }
    // The store is the source of truth for add-ons across the Stripe round
    // trip. The mock-billing URL also carries them, so a customer whose
    // localStorage was cleared mid-flow still arrives with their selection.
    const fromUrl = (params.get("addons") ?? "").split(",").map((s) => s.trim()).filter(Boolean);
    if (fromUrl.length && !(useWizardStore.getState().addons ?? []).length) {
      setAddons(fromUrl);
    }
    const t = setTimeout(() => navigate("/questionnaire", { replace: true }), 400);
    return () => clearTimeout(t);
  }, [navigate, params, setPlan, setAddons]);

  return (
    <Shell title="Payment confirmed" subtitle="Setting up your trial — one moment.">
      <div className="text-sm" style={{ color: "var(--color-muted)" }}>
        Redirecting to your site questionnaire…
      </div>
    </Shell>
  );
}
